import WorkspaceList from '../components/workspace/WorkspaceList';

const WorkspaceSettingsPage: React.FC = () => {
  return <WorkspaceList />;
};

export default WorkspaceSettingsPage;
